import React from 'react'

import { getLocationURL, getPimBaseUrl, getProductOriginURL } from '../../../../../utils/config'
import { fetchData } from '../../../../../utils/actions'
import SST_NAIL_ENUM from '../../../common/json/SST_NAIL_ENUM.json'
import seriesInfo from '../../../common/json/seriesInfo.json'

import { gaEventWrapper, flattenMultiLevelObject } from '../../../../../utils/utils'

import ReactHtmlParser from 'react-html-parser'
import { HANGER_TYPE } from '../../../common/constants'

const formatEntries = (obj, labelName) => {
  const flattedObj = flattenMultiLevelObject(obj)

  return Object.entries(flattedObj).reduce((result, [key, val]) => {
    if (val == undefined) {
      return result
    } else {
      return result + ' - ' + key + ':' + val
    }
  }, labelName)
}

export const formatEventResponse = (output) => {
  const { loading, data, error } = output
  let response = null
  if (loading === 'succeeded' && data && data.length > 0) {
    response = {
      isError: false,
      isEmpty: false,
    }
  } else if (loading === 'succeeded' && (!data || data.length === 0)) {
    response = {
      isError: false,
      isEmpty: true,
      message: error,
    }
  } else if (loading === 'failed') {
    response = {
      isError: true,
      message: error,
    }
  }
  return response
}

export const appEventWrapperUseQuery = (gaActionName, gaLabelName, query, output) => {
  const status = formatEventResponse(output.result ? output.result : output)

  let resp = {}
  if (status.isError === false && status.isEmpty && status.message) {
    resp = { solutionFound: 'No', message: status.message }
  } else if (status.isError === false && status.isEmpty) {
    resp = { solutionFound: 'No' }
  } else if (status.isError === false) {
    resp = { solutionFound: 'Yes' }
  } else {
    resp = { solutionFound: 'No', message: status.message }
  }

  const gaInput = Object.assign({}, query, resp)

  const eventLabel = formatEntries(gaInput, gaLabelName)

  // console.log('eventLabel=', eventLabel)

  gaEventWrapper('HS_Events', gaActionName, eventLabel)
}

export const appEventWrapper = (gaActionName, gaLabelName, input, output) => {
  let status = {}

  if (output) {
    if (output.loading && output.data) {
      // from global
      status = formatEventResponse(output)
    } else if (output.lstHgrOutput || output.lstTrussOutput) {
      // from Calculation
      const { lstHgrOutput, lstTrussOutput, errors } = output
      const data = lstHgrOutput || lstTrussOutput || []
      const loading = 'succeeded'
      const error = errors
      status = formatEventResponse({ loading, data, error })
    }
  }

  const { jobSettings, setting, hangerOptions, member } = input
  const { hangerType, fastenerType, designInformations, configuration, jobID, quantity, ansitpi } =
    jobSettings
  const { country, connectionType } = setting
  const { header, girder, joist, truss, jack, leftHip, rightHip } = member
  const topFlangeOptions = hangerType === 2 ? hangerOptions.topFlangeOptions : null
  const multiTrussMember = {
    leftCenterRight: {
      jack,
      leftHip,
      rightHip,
    },
    leftRight: {
      leftHip,
      rightHip,
    },
    leftCenter: {
      jack,
      leftHip,
    },
    rightCenter: {
      jack,
      rightHip,
    },
  }
  const memberData = {
    joist: {
      header,
      joist,
    },
    truss: {
      ansitpi,
      girder,
      truss,
    },
    multiTruss: {
      ansitpi,
      configuration,
      girder,
      ...multiTrussMember[configuration],
    },
  }

  // convert to gaInput for GA event format
  let gaInput = {
    country,
    connectionType,
    hangerType,
    fastenerType,
    ...designInformations,
    // jobID,
    quantity,
    topFlangeOptions,
    ...memberData[connectionType],
  }

  let resp = {}
  if (status.isError === false && status.isEmpty) {
    resp = { solutionFound: 'No' }
  } else if (status.isError === false) {
    resp = { solutionFound: 'Yes' }
  } else {
    resp = { solutionFound: 'No', message: status.message }
  }

  gaInput = Object.assign({}, gaInput, resp)

  const eventLabel = formatEntries(gaInput, gaLabelName)

  console.log('eventLabel=', eventLabel)

  gaEventWrapper('HS_Events' /* appConfig.gaEventName */, gaActionName, eventLabel)
}

// e.g. https://www.strongtie.com/search?v=CC+CC44X%3Arelevance&format=json
// Todo PDPUrl need to be updated when interface to EC
const handleProductLinkClick = (model, series, hangerType) => {
  const baseUrl = getProductOriginURL()

  const hangerTypeString =
    hangerType === HANGER_TYPE.CONCEALED
      ? 'Concealed-Flange'
      : hangerType === HANGER_TYPE.TOP_FLANGE
      ? 'Top-Flange'
      : ''
  const searchUrl = 'https://www.strongtie.com/search?v=' + model + '%3Arelevance' + '&format=json'

  let windowReference

  const launchPDPUrl = async () => {
    try {
      const result = await fetchData(searchUrl)
      let PDPUrl = null

      if (
        result &&
        result.data &&
        result.data.brResults &&
        result.data.brResults.product &&
        result.data.brResults.product.searchPageData &&
        result.data.brResults.product.searchPageData.results[0]
      ) {
        const products = result.data.brResults.product.searchPageData.results

        if (products.length === 1) {
          PDPUrl = products[0].url
        } else {
          let targetProduct = products.find((item) => item.code === series)
          if (!targetProduct && hangerTypeString) {
            targetProduct = products.find((item) =>
              item.descriptionShorts.includes(hangerTypeString),
            )
          }

          if (targetProduct) {
            PDPUrl = targetProduct.url
          } else {
            PDPUrl = products[0].url
          }
        }

        // console.log('--result -- PDPurl ', PDPUrl)

        // const ECUrl = (window.location != window.parent.location)
        // ? document.referrer.substring(0, document.referrer.length - 1)
        // : document.location.origin;

        windowReference = window.open(baseUrl + PDPUrl)

        if (window.focus && windowReference) {
          windowReference.focus()
        }
      }
    } catch (error) {
      console.log('--search API error--', error)
    }
  }

  launchPDPUrl()
}

const getFastenerLink = (type) => {
  const itemObj = type > 0 ? SST_NAIL_ENUM.find((item) => item.enum === type) : null
  if (!itemObj || !itemObj.url) {
    return '-'
  }

  return getProductOriginURL() + `/${itemObj.url}`
}

const getFastenerLabel = (type) => {
  const itemObj = SST_NAIL_ENUM.find((item) => item.enum === type)

  return itemObj ? itemObj.label : 'enum' + type
}

const displayFastener = (qty, type) => (qty && qty > 0 ? qty + '-' + getFastenerLabel(type) : '-')

const displayJoistFastener = (qty, type) =>
  qty && qty > 0 ? qty + '-' + getFastenerLabel(type) : getFastenerLabel(type)

// This is for fastener display in Result Table and Job Tally
const getFastenerDisplayLabel = (type) => {
  const itemObj = SST_NAIL_ENUM.find((item) => item.enum === type)

  if (!itemObj) {
    return 'enum' + type
  } else {
    return itemObj.displayLabel ? itemObj.displayLabel : itemObj.label
  }
}

const formatFastenerLabel = (qty, type) =>
  qty && qty > 0 ? '(' + qty + ') ' + getFastenerDisplayLabel(type) : '-'

const formatJoistFastenerLabel = (qty, type) =>
  qty && qty > 0 ? '(' + qty + ') ' + getFastenerDisplayLabel(type) : getFastenerDisplayLabel(type)

// JobTally
const formatFastenerEntry = (key, prefix, mQty, qty, type) =>
  qty && qty > 0 ? [{ key: key, prefix: prefix, value: displayFastener(mQty * qty, type) }] : []

// JobTally
const fastenersPerJob = (original) => {
  const ModelQuantity = original.input.jobSettings.quantity
  const { tfNailQty, tfNailType, hNailQty, hNailType, jNailQty, jNailType } = original

  let list = []
  list = list
    .concat(
      formatFastenerEntry('tf', 'Top Flange Fasteners: ', ModelQuantity, tfNailQty, tfNailType),
    )
    .concat(formatFastenerEntry('h', 'Face Fasteners: ', ModelQuantity, hNailQty[0], hNailType[0]))
    .concat(formatFastenerEntry('j', 'Joist Fasteners: ', ModelQuantity, jNailQty, jNailType))

  return list
}

const displayFastenerAnchor = (targetType, value) => {
  const link = getFastenerLink(targetType)
  const fastenerValue = (val) => {
    const splits = val.split(' (')
    const edited = splits.length === 2 ? splits[0] + '<br/>(' + splits[1] : val
    return (
      <div className="" style={{ whiteSpace: 'nowrap' }}>
        {ReactHtmlParser(edited)}
      </div>
    )
  }
  return link !== '-' ? (
    <a className="" href={link} target="_blank" title="" rel="noreferrer">
      {fastenerValue(value)}
    </a>
  ) : (
    <>{fastenerValue(value)}</>
  )
}

const formatEntry = (mQty, qty, type) => (qty && qty > 0 ? [{ type: type, qty: mQty * qty }] : [])

const splitAndFormatEntry = (mQty, fasteners) => {
  if (fasteners) {
    // const splits = fasteners.split('-')
    const indexOfFirst = fasteners.indexOf('-')
    const qty = fasteners.substring(0, indexOfFirst)
    const type = fasteners.substring(indexOfFirst + 1, fasteners.length)
    return formatEntry(mQty, qty, type)
  } else {
    return []
  }
}

const fastenerListPerJob = (job) => {
  const { quantity, tfFasteners, fFasteners, jFasteners } = job

  let list = []
  list = list
    .concat(splitAndFormatEntry(quantity, tfFasteners))
    .concat(splitAndFormatEntry(quantity, fFasteners))
    .concat(splitAndFormatEntry(quantity, jFasteners))

  return list
}

const fastenersTotal = (jobs) => {
  const temp = jobs.reduce((result, job) => {
    result = result.concat(fastenerListPerJob(job))
    return result
  }, [])

  const typeList = temp.reduce((result, entry) => {
    let obj = result.find((item) => item.type === entry.type)
    if (obj) {
      obj.qty = obj.qty + entry.qty
    } else {
      result.push(entry)
    }
    return result
  }, [])

  const total = typeList.reduce((result, entry) => {
    const item = SST_NAIL_ENUM.find((item) => item.label === entry.type)
    result =
      result +
      '(' +
      entry.qty +
      ') ' +
      (item.displayLabel ? item.displayLabel : item.label) +
      '<br/>'
    return result
  }, '')

  return total
}

const editedSpec = (spec, hlcFlush, hangerType) => {
  const specCondition =
    spec.includes('TFD') ||
    (hangerType === HANGER_TYPE.TOP_FLANGE &&
      (spec.includes('SLD') || spec.includes('SLU')) &&
      (spec.includes('SKL') || spec.includes('SKR')))

  if (spec && specCondition) {
    const hlcFlushList = ['L', 'C', 'H']
    return spec + ' HLC' + hlcFlushList[hlcFlush]
  } else {
    return spec
  }
}

const addSeriesInfo = (row) => {
  const str1 = row.model.replace(/\d+/g, '')
  const str2 = row.model.replace(/(^\D+)(\d+)(.+$)/i, '$1') // SUR, SUL, THAR, THAL, THASR, THASL
  const str3b = row.model.replace(/(^\D+)(R|L)(\d+)(.+$)/i, '$1') // SU, THA, THAS
  const str4 = row.model.split('-')[0] // MTHMQ-SDS3

  const seriesList = str1 === str2 ? [str1 + '_'] : [str1 + '_', str2 + '_']

  let seriesObj = null
  for (let i = 0; i < seriesList.length; i++) {
    seriesObj = seriesInfo.find((entry) => entry.series.indexOf(seriesList[i]) === 0)
    if (seriesObj) {
      break
    }
  }
  if (!seriesObj) {
    seriesObj = seriesInfo.find(
      (entry) => entry.series.indexOf(str3b + 'R-L') === 0 && entry.fileName.includes(str2),
    )

    if (!seriesObj) {
      seriesObj = seriesInfo.find((entry) => entry.series.indexOf(str4) === 0)
    }
  }

  // const webStiffeners = row.notes.find((item) => item.includes('Web stiffeners are required'))
  const webStiffeners = row.note === 1 ? true : false // HGRS-272

  const ici = row.ici === 0 ? 999999 : row.ici

  return {
    ...row,
    ici: ici,
    series: seriesObj ? seriesObj.series : 'TBD',
    seriesIllustration: seriesObj ? seriesObj.link : 'TBD',
    webStiffeners,
  }
}

export {
  handleProductLinkClick,
  displayFastener,
  displayJoistFastener,
  fastenersPerJob,
  formatFastenerLabel,
  formatJoistFastenerLabel,
  getFastenerLink,
  formatEntries,
  displayFastenerAnchor,
  fastenerListPerJob,
  fastenersTotal,
  editedSpec,
  addSeriesInfo,
}
